import axios from 'axios';
import { store } from '../store';
import { relogIn } from './userActions';
import { log } from './logActions';
import { logOut } from '../slices/user';

const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    withCredentials: true,
    headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: '*/*',
        'X-Api-Token': process.env.REACT_APP_API_TOKEN,
    },
});

instance.interceptors.request.use(
    function (config) {
        config.params = {
            webapp: 1,
            userId: store.getState().user.userId,
            ...config.params,
        };
        return config;
    },
    function (error) {
        return Promise.reject(error);
    },
);

instance.interceptors.response.use(
    (response) => {
        const method = response.config.method;
        const url = response.config.url;
        const payloadData = response.config.data; // Note: this is the raw request payload as a string
        const payloadParams = response.config.params;

        if (
            typeof response?.data === 'string' &&
            (response?.data?.indexOf('Attempt to read property "id" on null') !== -1 ||
                response?.data?.indexOf('HTTP 401 Unauthorized - WebApplicationException') !== -1)
        ) {
            const { reLoggedIn } = store.getState().user;

            // console.log('reLOg', reLoggedIn);
            if (reLoggedIn < 3 || reLoggedIn === undefined) {
                store.dispatch(relogIn());
                store.dispatch(
                    log({
                        method: `${method}-${url}`,
                        payload: `${payloadData}-${JSON.stringify(payloadParams)}`,
                        error: 'HTTP 401 Unauthorized',
                    }),
                );
            } else {
                store.dispatch(logOut());
            }
        }

        if (response.status === 200 && typeof response.data === 'object') {
            // console.log('passed')
        } else {
            // console.log('Error pay data', response.config);
            let payload = '';
            if (payloadData !== undefined) {
                payload += payloadData + '-';
            }
            payload += JSON.stringify(payloadParams);

            // console.log('Server error', `${method}-${url}`, payload);

            store.dispatch(
                log({
                    method: `${method}-${url}`,
                    payload,
                    error: typeof response.data === 'string' ? response.data : 'Error',
                }),
            );
        }
        return response;
    },
    (error) => {
        console.log('error axios', error);

        if (error.response) {
            try {
                const method = error.config.method;
                const url = error.config.url;
                const payloadData = error.config.data;
                const payloadParams = JSON.stringify(error.config.params);

                let payload = '';
                if (payloadData !== undefined) {
                    payload += payloadData + '-';
                }

                payload += payloadParams;

                const serverErrorDetails = error.response.data;
                const errorMessage =
                    typeof serverErrorDetails === 'string' ? serverErrorDetails : JSON.stringify(serverErrorDetails);

                console.log('Server error', `${method}-${url}`, payload, errorMessage);

                store.dispatch(
                    log({
                        method: `${method}-${url}`,
                        payload,
                        error: errorMessage,
                    }),
                );
            } catch (err) {
                console.log('axios log error', err);
            }
        }

        return Promise.reject(error);
    },
);

export default instance;
